const initialState = {
  isAuthenticated: false,
  user: null,
  headerName: 'Dashboard',
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.idToken,
        userId:action.payload.userId,
        facilityId:action.payload.facilityId,
        companyId:action.payload.companyId
      };
    case 'LOGOUT':
      return initialState;
    case 'SET_HEADER_NAME':
      return {
        ...state,
        headerName: action.payload,
      };
    case 'SET_INDEX_LABEL':
      return {
        ...state,
        selectedIndex: action.payload,
      };
    default:
      return state;
  }
};

export default authReducer;


